import { useTranslation } from "react-i18next";
import { MessengerChatInput } from "@/components/chat/MessengerChatInput";
import type { HandshakeSessionDetail } from "@/types";
import { ClosedConversationNotice } from "./ClosedConversationNotice";

interface HandshakeAdminPartnerComposerProps {
  session: HandshakeSessionDetail;
  canSend: boolean;
  isSending: boolean;
  onSend: (content: string) => Promise<void>;
}

export function HandshakeAdminPartnerComposer({
  session,
  canSend,
  isSending,
  onSend,
}: HandshakeAdminPartnerComposerProps) {
  const { t } = useTranslation(["handshakePages", "handshake"]);
  const { t: tCommon } = useTranslation("common");
  const isActive = session.status === "PENDING";

  if (!canSend) {
    return null;
  }

  if (isActive) {
    return (
      <MessengerChatInput
        onSend={onSend}
        isSending={isSending}
        placeholder={t("handshakePages:adminReplyPlaceholder")}
        sendLabel={t("handshake:messageInput.send")}
        loadingLabel={tCommon("loading")}
      />
    );
  }

  return (
    <div className="border-t border-surface-100 bg-surface-50 px-4 py-3">
      <ClosedConversationNotice status={session.status} />
    </div>
  );
}
